export const PollSmsTypes = {
  SHOW_SURVEY_SMS: "SHOW_SURVEY_SMS",
  SHOW_SURVEY_RESIDENT: "SHOW_SURVEY_RESIDENT",
  SEND_SMS_PREVIEW: "POLL_SEND_SMS_PREVIEW",
  SEND_SMS_DEBT: "POLL_SEND_SMS_DEBT",
};
